"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4124],{

/***/ 77737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85119);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88393);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67841);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98786);







var ValidatorMintResult = function(param) {
    var chainId = param.chainId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), shareLinkOpened = ref[0], setShareLinkOpened = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), shareLink = ref1[0], setShareLink = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var address = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().address;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setShareLink(window.location.href);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "max-w-[994px] mx-auto pb-[115px] px-5 sm:px-0 mt-10 sm:mt-[83px] animate__animated animate__fadeInUp",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-[#EBF3FF] rounded-2xl p-4 sm:p-20 flex flex-col items-center",
                style: {
                    boxShadow: "2px 4px 16px rgba(0, 0, 0, 0.05)"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-[37px] font-bold text-dark1 text-center max-w-[834px]",
                        children: "Congratulations on becoming a Validator"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-2 text-dark1 text-center max-w-[409px] leading-snug",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Your NFT will be revealed in the next few days, together with validator dashboard and score system."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "mt-5",
                                children: [
                                    "You will soon be able to recruit members to the network using your referral link and start earning Karat score and rewards.",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .Tooltip */ .u, {
                                        width: 220,
                                        multiline: true,
                                        withArrow: true,
                                        events: {
                                            focus: true,
                                            hover: true,
                                            touch: true
                                        },
                                        arrowSize: 10,
                                        classNames: {
                                            tooltip: "text-start"
                                        },
                                        label: "Your Karat score is calculated based on the number of referrals you have",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "ml-2 inline",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__/* .QuestionIcon */ .UO, {
                                                className: "fill-primary w-[14px] h-[14px] action inline"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-[223px] bg-white rounded-lg mt-10 p-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "w-full mt-4 scale-[1.1]",
                            src: "/assets/mint/demo-id-card.png"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col items-center mt-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z, {
                    classNames: {
                        inner: "text-body ",
                        root: "w-[255px] mt-4"
                    },
                    size: "md",
                    radius: "xl",
                    onClick: function() {
                        window.open("https://www.okx.com/web3?wallet=".concat(address), "_blank");
                    },
                    children: "View your NFT"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ValidatorMintResult);


/***/ }),

/***/ 16385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AE": function() { return /* binding */ AvailableNetworks; }
/* harmony export */ });
/* unused harmony exports BSCIcon, EthereumIcon, PolygonIcon, AvalancheIcon */
/* harmony import */ var wagmi_chains__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31407);

var BSCIcon = "/airdrop_assets/network/bsc.png";
var EthereumIcon = "/airdrop_assets/network/ethereum.png";
var PolygonIcon = "/airdrop_assets/network/polygon-matic-logo.png";
var AvalancheIcon = "/airdrop_assets/network/avalanche-avax-logo.png";
var AvailableNetworks = [
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .mainnet */ .RJ,
        name: "Ethereum",
        isTestNetwork: false,
        icon: EthereumIcon
    },
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .polygon */ .yu,
        name: "Polygon",
        isTestNetwork: false,
        icon: PolygonIcon
    },
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .avalanche */ .pL,
        name: "Avalanche",
        isTestNetwork: false,
        icon: AvalancheIcon
    },
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .bsc */ .eG,
        name: "BSC",
        isTestNetwork: false,
        icon: BSCIcon
    },
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .zkSync */ .jM,
        name: "zkSync",
        isTestNetwork: false,
        icon: "https://portal.zksync.io/favicon.ico"
    },
    {
        config: wagmi_chains__WEBPACK_IMPORTED_MODULE_0__/* .goerli */ .ws,
        name: "Goerli",
        isTestNetwork: true,
        icon: EthereumIcon
    }, 
];
if (false) {}


/***/ }),

/***/ 52492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMintValidator; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(70655);
/* harmony import */ var _hooks_useBridge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37091);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69077);
/* harmony import */ var wagmi_actions__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(17276);
/* harmony import */ var _services_network_validator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33186);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98786);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27234);
/* harmony import */ var _chain_info_contracts_ValidatorNFT_json__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94697);
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35055);
/* harmony import */ var viem__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(58903);
/* harmony import */ var _hooks_useMintHistory__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56146);
/* harmony import */ var _hooks_useRequest__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21706);
/* harmony import */ var _hooks_useValidatorContract__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75509);
/* harmony import */ var _hooks_useMintType__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70850);
/* harmony import */ var _hooks_useMintResult__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(24455);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11772);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8891);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(mixpanel_browser__WEBPACK_IMPORTED_MODULE_14__);




















function useMintValidator() {
    var ref = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), address = ref.address, isLogin = ref.isLogin, login = ref.login;
    var chain = (0,wagmi__WEBPACK_IMPORTED_MODULE_15__/* .useNetwork */ .LN)().chain;
    var ref1 = (0,_hooks_useBridge__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), depositSuccess = ref1.depositSuccess, depositing = ref1.depositing, karatDeposit = ref1.karatDeposit, zkSyncDeposit = ref1.zkSyncDeposit;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), minting = ref2[0], setMinting = ref2[1];
    var switchNetworkAsync = (0,wagmi__WEBPACK_IMPORTED_MODULE_15__/* .useSwitchNetwork */ .g0)().switchNetworkAsync;
    var form = (0,_hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().form;
    var ref3 = (0,_hooks_useMintHistory__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(), mintHistory = ref3.history, mintStatus = ref3.status;
    var mintType = (0,_hooks_useMintType__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), mintId = ref4[0], setMintId = ref4[1];
    var mintResultRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({
        timer: null,
        result: null,
        success: false,
        error: null
    });
    var ref5 = (0,_hooks_useMintResult__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(mintId), mintResult = ref5.data, isMintSuccess = ref5.isSuccess, mintError = ref5.error;
    var validatorContractInfo = (0,_hooks_useValidatorContract__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK);
    var validatorContract = (0,_stores__WEBPACK_IMPORTED_MODULE_5__/* .useTypedSelector */ .ix)(function(state) {
        return state.devtool.config.validatorContract;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        mintResultRef.current.result = mintResult;
        mintResultRef.current.success = isMintSuccess;
        mintResultRef.current.error = mintError;
    }, [
        mintResult,
        isMintSuccess,
        mintError
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            mintResultRef.current.timer && clearInterval(mintResultRef.current.timer);
        };
    }, []);
    var ref6 = (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(mintType === "validator" && address && validatorContractInfo.stage === 1 ? {
        function: "validator/getWhiteListInfo",
        data: {
            walletAddress: address
        },
        header: {
            endpoint: "network"
        }
    } : null), whiteListInfo = ref6.data, whiteListError = ref6.error;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!address) {
            return;
        }
        if ([
            "0x89af1676d510f0a037cf85f7f175f5e50154c9ed"
        ].includes(address.toLowerCase()) || whiteListError) {
            if (whiteListError || whiteListInfo) {
                _sentry_nextjs__WEBPACK_IMPORTED_MODULE_13__/* .captureEvent */ .eN({
                    message: "whitelist debug",
                    extra: {
                        address: address,
                        error: whiteListError,
                        info: whiteListInfo
                    }
                });
            }
        }
    }, [
        whiteListInfo,
        address,
        whiteListError
    ]);
    var ref7 = (0,wagmi__WEBPACK_IMPORTED_MODULE_15__/* .useContractWrite */ .GG)({
        address: validatorContract,
        abi: _chain_info_contracts_ValidatorNFT_json__WEBPACK_IMPORTED_MODULE_6__/* .abi */ .Mt,
        functionName: "mintValidatorPublic",
        chainId: _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK,
        args: [
            address,
            2
        ],
        gas: 40000000n,
        value: (0,viem__WEBPACK_IMPORTED_MODULE_16__/* .parseEther */ .f)(String(0.2))
    }), mintValidatorPublicByContract = ref7.writeAsync, publicMintData = ref7.data;
    var ref8 = (0,wagmi__WEBPACK_IMPORTED_MODULE_15__/* .useContractWrite */ .GG)({
        address: validatorContract,
        abi: _chain_info_contracts_ValidatorNFT_json__WEBPACK_IMPORTED_MODULE_6__/* .abi */ .Mt,
        functionName: "mintValidatorPrivate",
        chainId: _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK,
        args: [
            address,
            parseInt((whiteListInfo === null || whiteListInfo === void 0 ? void 0 : whiteListInfo.tier) || "2"),
            (0,viem__WEBPACK_IMPORTED_MODULE_16__/* .parseEther */ .f)((whiteListInfo === null || whiteListInfo === void 0 ? void 0 : whiteListInfo.mintPrice) || "0"),
            whiteListInfo === null || whiteListInfo === void 0 ? void 0 : whiteListInfo.proof, 
        ],
        gas: 80000000n,
        value: (0,viem__WEBPACK_IMPORTED_MODULE_16__/* .parseEther */ .f)((whiteListInfo === null || whiteListInfo === void 0 ? void 0 : whiteListInfo.mintPrice) || "0")
    }), mintValidatorPrivateByContract = ref8.writeAsync, mintData = ref8.data;
    var ref9 = (0,wagmi__WEBPACK_IMPORTED_MODULE_15__/* .useWaitForTransaction */ .BX)({
        hash: mintData === null || mintData === void 0 ? void 0 : mintData.hash,
        chainId: _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK
    }), fetchTransaction = ref9.refetch;
    var ref10 = (0,wagmi__WEBPACK_IMPORTED_MODULE_15__/* .useWaitForTransaction */ .BX)({
        hash: publicMintData === null || publicMintData === void 0 ? void 0 : publicMintData.hash,
        chainId: _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK
    }), fetchPublicTransaction = ref10.refetch;
    var checkWhiteList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (mintType !== "validator") {
            return;
        }
        if (validatorContractInfo.stage === 1 && whiteListError) {
            throw new Error(whiteListError.message);
        }
        if (validatorContractInfo.stage === 0) {
            throw new Error("Mint closed");
        }
    }, [
        whiteListError,
        mintType,
        validatorContractInfo
    ]);
    var contractMint = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
        var res, transReceipt, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setMinting(true);
                    console.log("start contract mint");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        13,
                        14
                    ]);
                    if (!isLogin) {
                        login();
                        return [
                            2,
                            false
                        ];
                    }
                    checkWhiteList();
                    if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK)) return [
                        3,
                        3
                    ];
                    // @ts-ignore
                    return [
                        4,
                        switchNetworkAsync(_config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    if (!((validatorContractInfo === null || validatorContractInfo === void 0 ? void 0 : validatorContractInfo.stage) === 1)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        mintValidatorPrivateByContract()
                    ];
                case 4:
                    res = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        mintValidatorPublicByContract()
                    ];
                case 6:
                    res = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        4,
                        (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_19__/* .waitForTransaction */ .Mn)(res)
                    ];
                case 8:
                    transReceipt = _state.sent();
                    if (transReceipt.status === "reverted") {
                        throw new Error("Mint fail");
                    }
                    if (!((validatorContractInfo === null || validatorContractInfo === void 0 ? void 0 : validatorContractInfo.stage) === 1)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        fetchTransaction()
                    ];
                case 9:
                    data = _state.sent();
                    return [
                        3,
                        12
                    ];
                case 10:
                    return [
                        4,
                        fetchPublicTransaction()
                    ];
                case 11:
                    data = _state.sent();
                    _state.label = 12;
                case 12:
                    console.log("mint trans", data);
                    if (data.error) {
                        throw new Error(data.error.reason);
                    }
                    _stores__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_5__/* .actions.mint.setHistory */ .Nw.mint.setHistory({
                        history: null,
                        type: "validator"
                    }));
                    return [
                        2,
                        true
                    ];
                case 13:
                    setMinting(false);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchTransaction,
        fetchPublicTransaction,
        mintValidatorPublicByContract,
        mintValidatorPrivateByContract,
        switchNetworkAsync,
        chain,
        _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK,
        isLogin,
        checkWhiteList, 
    ]);
    var karatRecoverMint = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
        var res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!isLogin) {
                        login();
                        return [
                            2,
                            false
                        ];
                    }
                    checkWhiteList();
                    setMinting(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        7,
                        8
                    ]);
                    if (!form.recover_tx) {
                        throw new Error("miss transaction hash");
                    }
                    mixpanel_browser__WEBPACK_IMPORTED_MODULE_14___default().track("recover_mint_validator", {
                        walletAddress: address,
                        tier: 2,
                        depositChainId: form.recover_chain || 1,
                        depositTransactionHash: form.recover_tx
                    });
                    console.log("start karat mint");
                    if (!((validatorContractInfo === null || validatorContractInfo === void 0 ? void 0 : validatorContractInfo.stage) === 1)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0,_services_network_validator__WEBPACK_IMPORTED_MODULE_3__/* .mintValidatorPrivate */ .k8)({
                            walletAddress: address,
                            depositChainId: form.recover_chain || 1,
                            depositTransactionHash: form.recover_tx
                        })
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        (0,_services_network_validator__WEBPACK_IMPORTED_MODULE_3__/* .mintValidatorPublic */ .fL)({
                            walletAddress: address,
                            tier: 2,
                            depositChainId: form.recover_chain || 1,
                            depositTransactionHash: form.recover_tx
                        })
                    ];
                case 4:
                    res = _state.sent();
                    _state.label = 5;
                case 5:
                    console.log("mint res", res);
                    if (!res.mintId) {
                        throw new Error("miss mint id");
                    }
                    setMintId(res.mintId);
                    _stores__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_5__/* .actions.mint.clearHistory */ .Nw.mint.clearHistory({
                        tx: form.recover_tx
                    }));
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            mintResultRef.current.timer = setInterval(function() {
                                console.log("check mint", mintResultRef);
                                if (mintResultRef.current.error) {
                                    clearInterval(mintResultRef.current.timer);
                                    return reject(mintResultRef.current.error.message);
                                }
                                if (mintResultRef.current.success) {
                                    clearInterval(mintResultRef.current.timer);
                                    return resolve(true);
                                }
                            }, 1000);
                        })
                    ];
                case 6:
                    _state.sent();
                    console.log("karat mint success");
                    return [
                        2,
                        true
                    ];
                case 7:
                    setMinting(false);
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    }), [
        karatDeposit,
        chain,
        form,
        mintHistory,
        mintStatus,
        isLogin,
        checkWhiteList,
        validatorContractInfo, 
    ]);
    var karatMint = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
        var history, ref, escrowDepositInfo, chainId, res;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!isLogin) {
                        login();
                        return [
                            2,
                            false
                        ];
                    }
                    checkWhiteList();
                    if (!(mintHistory && mintStatus === "success")) return [
                        3,
                        1
                    ];
                    history = mintHistory;
                    return [
                        3,
                        5
                    ];
                case 1:
                    escrowDepositInfo = form === null || form === void 0 ? void 0 : form.karat;
                    chainId = (mintHistory === null || mintHistory === void 0 ? void 0 : mintHistory.chainId) || (escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : (ref = escrowDepositInfo.token) === null || ref === void 0 ? void 0 : ref.chainId);
                    if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== chainId)) return [
                        3,
                        3
                    ];
                    // @ts-ignore
                    return [
                        4,
                        switchNetworkAsync(chainId)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        karatDeposit()
                    ];
                case 4:
                    history = _state.sent();
                    _state.label = 5;
                case 5:
                    setMinting(true);
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        ,
                        13,
                        14
                    ]);
                    return [
                        4,
                        new Promise(function(resolve) {
                            setTimeout(resolve, 3000);
                        })
                    ];
                case 7:
                    _state.sent();
                    console.log("start karat mint");
                    if (!((validatorContractInfo === null || validatorContractInfo === void 0 ? void 0 : validatorContractInfo.stage) === 1)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        (0,_services_network_validator__WEBPACK_IMPORTED_MODULE_3__/* .mintValidatorPrivate */ .k8)({
                            walletAddress: address,
                            depositChainId: history.chainId,
                            depositTransactionHash: history.transaction
                        })
                    ];
                case 8:
                    res = _state.sent();
                    return [
                        3,
                        11
                    ];
                case 9:
                    return [
                        4,
                        (0,_services_network_validator__WEBPACK_IMPORTED_MODULE_3__/* .mintValidatorPublic */ .fL)({
                            walletAddress: address,
                            tier: 2,
                            depositChainId: history.chainId,
                            depositTransactionHash: history.transaction
                        })
                    ];
                case 10:
                    res = _state.sent();
                    _state.label = 11;
                case 11:
                    console.log("mint res", res);
                    if (!res.mintId) {
                        throw new Error("miss mint id");
                    }
                    setMintId(res.mintId);
                    _stores__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_5__/* .actions.mint.setHistory */ .Nw.mint.setHistory({
                        history: null,
                        type: "validator"
                    }));
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            mintResultRef.current.timer = setInterval(function() {
                                console.log("check mint", mintResultRef);
                                if (mintResultRef.current.error) {
                                    clearInterval(mintResultRef.current.timer);
                                    return reject(mintResultRef.current.error.message);
                                }
                                if (mintResultRef.current.success) {
                                    clearInterval(mintResultRef.current.timer);
                                    return resolve(true);
                                }
                            }, 1000);
                        })
                    ];
                case 12:
                    _state.sent();
                    console.log("karat mint success");
                    return [
                        2,
                        true
                    ];
                case 13:
                    setMinting(false);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2
                    ];
            }
        });
    }), [
        karatDeposit,
        chain,
        form,
        mintHistory,
        mintStatus,
        isLogin,
        checkWhiteList,
        validatorContractInfo, 
    ]);
    var zkSyncMint = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
        var zksyncDepositInfo, history, chainId;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!isLogin) {
                        login();
                        return [
                            2,
                            false
                        ];
                    }
                    checkWhiteList();
                    zksyncDepositInfo = form === null || form === void 0 ? void 0 : form.zksync;
                    console.log("zksyncDepositInfo", zksyncDepositInfo);
                    if (!(mintHistory && mintStatus === "success")) return [
                        3,
                        1
                    ];
                    history = mintHistory;
                    return [
                        3,
                        5
                    ];
                case 1:
                    chainId = String((mintHistory === null || mintHistory === void 0 ? void 0 : mintHistory.chainId) || (zksyncDepositInfo === null || zksyncDepositInfo === void 0 ? void 0 : zksyncDepositInfo.chain));
                    if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== parseInt(chainId))) return [
                        3,
                        3
                    ];
                    // @ts-ignore
                    return [
                        4,
                        switchNetworkAsync(parseInt(chainId))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        zkSyncDeposit()
                    ];
                case 4:
                    history = _state.sent();
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        ,
                        8,
                        9
                    ]);
                    setMinting(true);
                    return [
                        4,
                        new Promise(function(resolve) {
                            setTimeout(resolve, 3000);
                        })
                    ];
                case 6:
                    _state.sent();
                    return [
                        4,
                        contractMint()
                    ];
                case 7:
                    _state.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    setMinting(false);
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        true
                    ];
            }
        });
    }), [
        zkSyncDeposit,
        contractMint,
        form,
        switchNetworkAsync,
        mintHistory,
        mintStatus,
        isLogin,
        checkWhiteList, 
    ]);
    var mintBtnText = "Deposit & Mint";
    if (mintHistory && mintStatus === "success") {
        mintBtnText = "Mint";
    }
    var defaultDepositCost = 0.2;
    if (whiteListInfo && validatorContractInfo.stage === 1) {
        defaultDepositCost = parseFloat(whiteListInfo.mintPrice);
    }
    return {
        depositSuccess: depositSuccess,
        depositing: depositing,
        history: mintHistory,
        minting: minting,
        karatMint: karatMint,
        zkSyncMint: zkSyncMint,
        contractMint: contractMint,
        karatRecoverMint: karatRecoverMint,
        validatorContractInfo: validatorContractInfo,
        whiteListInfo: whiteListInfo,
        mintBtnText: mintBtnText,
        defaultDepositCost: defaultDepositCost
    };
}


/***/ }),

/***/ 75509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useValidatorContract; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69077);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98786);
/* harmony import */ var _services_contract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26720);





var Stage = {
    0: "Closed",
    1: "Pre-Sale",
    2: "Public-Sale"
};
function useValidatorContract(chainId) {
    var ref, ref1, ref2, ref3;
    var address = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().address;
    var contract = _services_contract__WEBPACK_IMPORTED_MODULE_1__/* .validatorContracts */ .Fv[chainId];
    var data = (0,wagmi__WEBPACK_IMPORTED_MODULE_2__/* .useContractReads */ .Dm)({
        watch: false,
        contracts: [
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, contract), {
                functionName: "currentStage"
            }),
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, contract), {
                functionName: "totalSupply"
            }),
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, contract), {
                functionName: "balanceOf",
                args: [
                    address
                ]
            }),
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, contract), {
                functionName: "privateValidatorMint",
                args: [
                    address
                ]
            }),
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, contract), {
                functionName: "mintBatch",
                args: [
                    1
                ]
            }), 
        ]
    }).data;
    var stage = Number((data === null || data === void 0 ? void 0 : (ref = data[0]) === null || ref === void 0 ? void 0 : ref.result) || 0);
    return {
        stage: stage,
        stageDesc: Stage[stage],
        quantity: Number((data === null || data === void 0 ? void 0 : (ref1 = data[1]) === null || ref1 === void 0 ? void 0 : ref1.result) || 0),
        isReady: !!data,
        balance: (data === null || data === void 0 ? void 0 : (ref2 = data[2]) === null || ref2 === void 0 ? void 0 : ref2.result) || 0n,
        privateMinted: !!(data === null || data === void 0 ? void 0 : data[3]),
        totalSupply: (data === null || data === void 0 ? void 0 : (ref3 = data[4]) === null || ref3 === void 0 ? void 0 : ref3.result) || 0n
    };
}


/***/ })

}]);